class DoubleCircleProgress implements ng.IComponentController {
    icon: string;
    val: string;
    circleTitle: string;
    smallVal: string | number;
    bigVal: string | number;
}

angular.module('animatronApp.doubleCircleProgress', []).component('doubleCircleProgress', {
    bindings: {
        icon: '<',
        val: '<',
        circleTitle: '<',
        bigVal: '<',
        smallVal: '<'
    },
    controller: DoubleCircleProgress,
    templateUrl: require('landing-template/components/double-circle-progress.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/DoubleCircleProgress.ts